module.exports = __webpack_public_path__ + "static/media/O49-2500.f3c760bc.jpg";